// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"FADUU","block":"ykyMD","element":"yvK2S","policy":"aME0v","contact":"_9S69T","title":"lBap3","list":"_7TLVU"};